'use client';

import Image from 'next/image';
import { useLanguage } from '@/contexts/language-context';

interface VAgentLogoProps {
  onClick?: () => void;
}

export default function VAgentLogo({ onClick }: VAgentLogoProps) {
  const { isRTL } = useLanguage();

  return (
    <button
      onClick={() => {
        window.open('https://aifo.com', '_blank', 'noopener,noreferrer');
        onClick?.();
      }}
      style={{
        position: 'fixed',
        top: 20,
        left: isRTL ? 'auto' : 16,
        right: isRTL ? 16 : 'auto',
        zIndex: 60,
      }}
      className="cursor-pointer hover:opacity-80 transition-opacity p-0 overflow-visible">
      <Image
        src="/logo.svg"
        alt="AIFO-Coach"
        width={108}
        height={28}
        className="block h-7 w-[108px]"
      />
    </button>
  );
}
